module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/services-1-0882d382fa742da643fe36a04f16b787.png";